import {
  Avatar,
  Button,
  Grid,
  Select,
  MenuItem,
  Stack,
  Typography,
  useMediaQuery,
  Popover,
} from '@mui/material';

import { Box } from '@mui/system';
import React, { useState } from 'react';
import { fontsize16, poppins400 } from 'theme/common.style';
import { poppins600 } from 'theme/common.style';
import { poppins700 } from 'theme/common.style';
import { poppins500 } from 'theme/common.style';
import { fontsize14, poppins300 } from 'theme/common.style';
import House from 'assets/images/House.png';
import Insightslogo from 'assets/icons/Insightslogo.svg';
import { BuyerCard2Buyermatch } from 'component/BuyerCard2Buyermatch/BuyerCard2Buyermatch';
import { makeStyles } from '@mui/styles';
import { Dialog, DialogContent } from '@mui/material';
import {
  MarketMetricsGraphFour,
  MarketMetricsGraphOne,
  MarketMetricsGraphThree,
  MarketMetricsGraphTwo,
} from './BuyerCard2Insights_Marketmetrics';
import { useTheme } from '@mui/material/styles';

export const BuyerCard2Insights = ({
  onClose,
  dropdownValue,
  onDropdownChange,
  propertyOwner,
  popover,
  buyerId,
  selectedProperty,
  ownercardpropaction,
}) => {
  const theme = useTheme();
  const matches1250 = useMediaQuery(theme.breakpoints.down(1250));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [openbuyermatch, setOpenbuyermatch] = useState(false);
  const [clickedrightarrow, setClickrightarrow] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClosebuyermatch = () => {
    setAnchorEl(null);
    setOpenbuyermatch(false);
  };
  const [expanded, setExpanded] = useState(false);
  const ExpandIcon = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M17.6924 7.19042L23.1825 7.19042L23.1825 12.6949"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.8633 7.5L17.6133 12.75"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M14.0381 21.8106L8.54795 21.8106L8.54795 16.3061"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1133 16.2559L8.86328 21.5059"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  };
  const RightArrow = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M14.1133 8.375L20.2061 14.4678L14.1133 20.5605"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const BedIcon = () => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12294_29983)">
          <path
            d="M2.10938 8.89211H14.6197C15.1354 8.89211 15.5533 8.47413 15.5533 7.95851C15.5533 7.44288 15.1354 7.0249 14.6197 7.0249H2.10938C1.59376 7.0249 1.17578 7.44288 1.17578 7.95851C1.17575 8.47413 1.59376 8.89211 2.10938 8.89211Z"
            fill="#6C2AD2"
          />
          <path
            d="M9.29884 5.01123C9.02635 5.01123 8.80469 5.23289 8.80469 5.50538V6.14602H12.6291V5.50538C12.6291 5.23289 12.4074 5.01123 12.1349 5.01123H9.29884Z"
            fill="#6C2AD2"
          />
          <path
            d="M3.21938 5.50547C3.21938 4.74835 3.83531 4.13241 4.59243 4.13241H7.42852C7.78881 4.13241 8.11693 4.2721 8.36212 4.49991C8.6073 4.2721 8.93543 4.13241 9.29572 4.13241H12.1318C12.8889 4.13241 13.5049 4.74835 13.5049 5.50547V6.1461H14.9313V3.11915C14.9313 2.60353 14.5133 2.18555 13.9977 2.18555H2.72657C2.21095 2.18555 1.79297 2.60353 1.79297 3.11915V6.1461H3.21938V5.50547Z"
            fill="#6C2AD2"
          />
          <path
            d="M4.59181 5.01123C4.31932 5.01123 4.09766 5.23289 4.09766 5.50538V6.14602H7.92204V5.50538C7.92204 5.23289 7.70038 5.01123 7.42789 5.01123H4.59181Z"
            fill="#6C2AD2"
          />
          <path
            d="M0.863281 9.77124V13.8147H1.74219V12.2123H14.9844V13.8147H15.8633V9.77124H0.863281Z"
            fill="#6C2AD2"
          />
        </g>
        <defs>
          <clipPath id="clip0_12294_29983">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.863281 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const ShowerIcon = () => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12294_29992)">
          <path
            d="M13.4883 0.5C13.0741 0.5 12.7383 0.835781 12.7383 1.25V1.5H7.23828C6.54828 1.50081 5.98909 2.06 5.98828 2.75V4H5.48828C5.07406 4 4.73828 4.33578 4.73828 4.75V5.61125C3.64931 6.28247 2.98678 7.47078 2.98828 8.75V9.046C2.68969 9.15156 2.48959 9.43331 2.48828 9.75V10.25C2.48828 10.3881 2.60022 10.5 2.73828 10.5H10.7383C10.8763 10.5 10.9883 10.3881 10.9883 10.25V9.75C10.987 9.43331 10.7869 9.15156 10.4883 9.046V8.75C10.4897 7.7545 10.0938 6.79959 9.38828 6.09725C9.19222 5.90819 8.97394 5.74356 8.73828 5.607V4.75C8.73828 4.33578 8.4025 4 7.98828 4H7.48828V3.25C7.48828 3.11194 7.60022 3 7.73828 3H12.7383V3.5C12.7383 3.91422 13.0741 4.25 13.4883 4.25H14.2383V0.5H13.4883ZM10.4883 9.75V10H2.98828V9.75C2.98828 9.61194 3.10022 9.5 3.23828 9.5H10.2383C10.3763 9.5 10.4883 9.61194 10.4883 9.75ZM9.03603 6.4515C9.64697 7.06022 9.98972 7.88756 9.98828 8.75V9H3.48828V8.75C3.48747 7.62038 4.08391 6.5745 5.05653 6H8.42178C8.64541 6.12297 8.85194 6.27475 9.03603 6.4515ZM7.98828 4.5C8.12634 4.5 8.23828 4.61194 8.23828 4.75V5.5H5.23828V4.75C5.23828 4.61194 5.35022 4.5 5.48828 4.5H7.98828ZM12.7383 2.5H7.73828C7.32406 2.5 6.98828 2.83578 6.98828 3.25V4H6.48828V2.75C6.48828 2.33578 6.82406 2 7.23828 2H12.7383V2.5ZM13.7383 3.75H13.4883C13.3502 3.75 13.2383 3.63806 13.2383 3.5V1.25C13.2383 1.11194 13.3502 1 13.4883 1H13.7383V3.75Z"
            fill="#6C2AD2"
          />
          <path
            d="M6.73828 11C6.60022 11 6.48828 11.1119 6.48828 11.25V12.25C6.48828 12.3881 6.60022 12.5 6.73828 12.5C6.87634 12.5 6.98828 12.3881 6.98828 12.25V11.25C6.98828 11.1119 6.87634 11 6.73828 11Z"
            fill="#6C2AD2"
          />
          <path
            d="M6.73828 13C6.60022 13 6.48828 13.1119 6.48828 13.25V14.25C6.48828 14.3881 6.60022 14.5 6.73828 14.5C6.87634 14.5 6.98828 14.3881 6.98828 14.25V13.25C6.98828 13.1119 6.87634 13 6.73828 13Z"
            fill="#6C2AD2"
          />
          <path
            d="M9.73828 12C9.60022 12 9.48828 12.1119 9.48828 12.25V13.25C9.48828 13.3881 9.60022 13.5 9.73828 13.5C9.87634 13.5 9.98828 13.3881 9.98828 13.25V12.25C9.98828 12.1119 9.87634 12 9.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M7.73828 12C7.60022 12 7.48828 12.1119 7.48828 12.25V13.25C7.48828 13.3881 7.60022 13.5 7.73828 13.5C7.87634 13.5 7.98828 13.3881 7.98828 13.25V12.25C7.98828 12.1119 7.87634 12 7.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M5.73828 12C5.60022 12 5.48828 12.1119 5.48828 12.25V13.25C5.48828 13.3881 5.60022 13.5 5.73828 13.5C5.87634 13.5 5.98828 13.3881 5.98828 13.25V12.25C5.98828 12.1119 5.87634 12 5.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M3.73828 12C3.60022 12 3.48828 12.1119 3.48828 12.25V13.25C3.48828 13.3881 3.60022 13.5 3.73828 13.5C3.87634 13.5 3.98828 13.3881 3.98828 13.25V12.25C3.98828 12.1119 3.87634 12 3.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M4.73828 11C4.60022 11 4.48828 11.1119 4.48828 11.25V12.25C4.48828 12.3881 4.60022 12.5 4.73828 12.5C4.87634 12.5 4.98828 12.3881 4.98828 12.25V11.25C4.98828 11.1119 4.87634 11 4.73828 11Z"
            fill="#6C2AD2"
          />
          <path
            d="M8.73828 11C8.60022 11 8.48828 11.1119 8.48828 11.25V12.25C8.48828 12.3881 8.60022 12.5 8.73828 12.5C8.87634 12.5 8.98828 12.3881 8.98828 12.25V11.25C8.98828 11.1119 8.87634 11 8.73828 11Z"
            fill="#6C2AD2"
          />
          <path
            d="M8.73828 13C8.60022 13 8.48828 13.1119 8.48828 13.25V14.25C8.48828 14.3881 8.60022 14.5 8.73828 14.5C8.87634 14.5 8.98828 14.3881 8.98828 14.25V13.25C8.98828 13.1119 8.87634 13 8.73828 13Z"
            fill="#6C2AD2"
          />
          <path
            d="M4.73828 13C4.60022 13 4.48828 13.1119 4.48828 13.25V14.25C4.48828 14.3881 4.60022 14.5 4.73828 14.5C4.87634 14.5 4.98828 14.3881 4.98828 14.25V13.25C4.98828 13.1119 4.87634 13 4.73828 13Z"
            fill="#6C2AD2"
          />
          <path
            d="M5.73828 14C5.60022 14 5.48828 14.1119 5.48828 14.25V15.25C5.48828 15.3881 5.60022 15.5 5.73828 15.5C5.87634 15.5 5.98828 15.3881 5.98828 15.25V14.25C5.98828 14.1119 5.87634 14 5.73828 14Z"
            fill="#6C2AD2"
          />
          <path
            d="M7.73828 14C7.60022 14 7.48828 14.1119 7.48828 14.25V15.25C7.48828 15.3881 7.60022 15.5 7.73828 15.5C7.87634 15.5 7.98828 15.3881 7.98828 15.25V14.25C7.98828 14.1119 7.87634 14 7.73828 14Z"
            fill="#6C2AD2"
          />
        </g>
        <defs>
          <clipPath id="clip0_12294_29992">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.863281 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const CarIcon = () => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12294_30034)">
          <path
            d="M11.5005 6.99815C11.4523 6.99815 11.4027 7.00509 11.3532 7.01868L10.7933 7.17291L10.212 5.7567C10.0473 5.3555 9.56046 5.02905 9.12679 5.02905H3.68596C3.25224 5.02905 2.76545 5.3555 2.60077 5.7567L2.02019 7.17093L1.46725 7.01863C1.41777 7.00503 1.36823 6.9981 1.31996 6.9981C1.05532 6.9981 0.863281 7.20026 0.863281 7.47872V7.80874C0.863281 8.13382 1.12781 8.39835 1.45288 8.39835H1.51624L1.42239 8.62693C1.26938 8.99956 1.14482 9.63066 1.14482 10.0337V12.8471C1.14482 13.1722 1.40935 13.4367 1.73442 13.4367H2.50445C2.82952 13.4367 3.09405 13.1722 3.09405 12.8471V12.1446H9.71864V12.8471C9.71864 13.1722 9.98317 13.4367 10.3082 13.4367H11.0782C11.4032 13.4367 11.6678 13.1722 11.6678 12.8471V10.0337C11.6678 9.63077 11.5432 8.99967 11.3902 8.62699L11.2963 8.3984H11.3676C11.6926 8.3984 11.9572 8.13387 11.9572 7.8088V7.47877C11.9572 7.20032 11.7651 6.99815 11.5005 6.99815ZM2.44285 8.07817L3.3223 5.93608C3.42083 5.6961 3.71365 5.49971 3.97306 5.49971H8.83969C9.0991 5.49971 9.39192 5.69604 9.49044 5.93608L10.3699 8.07817C10.4684 8.31815 10.3368 8.51454 10.0773 8.51454H2.73545C2.47599 8.51448 2.34439 8.31815 2.44285 8.07817ZM4.40601 10.7877C4.40601 10.9174 4.29984 11.0235 4.17021 11.0235H2.4996C2.36987 11.0235 2.26375 10.9174 2.26375 10.7877V9.98596C2.26375 9.85628 2.36987 9.75016 2.4996 9.75016H4.17021C4.29984 9.75016 4.40601 9.85628 4.40601 9.98596V10.7877ZM10.5331 10.7877C10.5331 10.9174 10.427 11.0235 10.2973 11.0235H8.62674C8.49711 11.0235 8.39094 10.9174 8.39094 10.7877V9.98596C8.39094 9.85628 8.49711 9.75016 8.62674 9.75016H10.2973C10.427 9.75016 10.5331 9.85628 10.5331 9.98596V10.7877Z"
            fill="#6C2AD2"
          />
          <path
            d="M15.1276 2.56323H12.3351C11.9285 2.56323 11.5977 2.89409 11.5977 3.30067V6.09325C11.5977 6.49989 11.9285 6.83074 12.3351 6.83074H13.4561V13.0984C13.4561 13.2504 13.5793 13.3736 13.7313 13.3736C13.8834 13.3736 14.0065 13.2504 14.0065 13.0984V6.8308H15.1276C15.5343 6.8308 15.8651 6.49995 15.8651 6.0933V3.30073C15.8651 2.89409 15.5343 2.56323 15.1276 2.56323ZM14.4951 4.87865C14.3345 5.02324 14.098 5.09656 13.792 5.09656H13.3877C13.3391 5.09656 13.2996 5.13613 13.2996 5.18468V5.86659C13.2996 5.94067 13.2393 6.00089 13.1652 6.00089H12.859C12.7848 6.00089 12.7246 5.94062 12.7246 5.86659V3.52761C12.7246 3.45347 12.7849 3.3932 12.859 3.3932H13.6304C14.1415 3.3932 14.3323 3.4702 14.489 3.60324C14.6544 3.74354 14.7381 3.95842 14.7381 4.24204C14.7381 4.51918 14.6564 4.73329 14.4951 4.87865Z"
            fill="#6C2AD2"
          />
          <path
            d="M14.0586 3.95803C13.984 3.90167 13.8519 3.87305 13.6662 3.87305H13.3888C13.3403 3.87305 13.3008 3.91257 13.3008 3.96106V4.52149C13.3008 4.56998 13.3403 4.6095 13.3888 4.6095H13.555C13.6161 4.6095 13.7147 4.60498 13.7749 4.59943C13.8333 4.59409 13.9981 4.5702 14.0586 4.52451C14.1312 4.46958 14.168 4.37458 14.168 4.24221C14.168 4.10857 14.1312 4.01296 14.0586 3.95803Z"
            fill="#6C2AD2"
          />
        </g>
        <defs>
          <clipPath id="clip0_12294_30034">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.863281 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const Graph = () => {
    return (
      <svg
        width="288"
        height="194"
        viewBox="0 0 288 194"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.092 28.252C8.092 28.7747 7.966 29.2647 7.714 29.722C7.47133 30.1793 7.084 30.548 6.552 30.828C6.02933 31.108 5.36667 31.248 4.564 31.248H2.926V35H0.966V25.228H4.564C5.32 25.228 5.964 25.3587 6.496 25.62C7.028 25.8813 7.42467 26.2407 7.686 26.698C7.95667 27.1553 8.092 27.6733 8.092 28.252ZM4.48 29.666C5.02133 29.666 5.42267 29.5447 5.684 29.302C5.94533 29.05 6.076 28.7 6.076 28.252C6.076 27.3 5.544 26.824 4.48 26.824H2.926V29.666H4.48ZM11.4436 28.448C11.6956 28.0373 12.0222 27.7153 12.4236 27.482C12.8342 27.2487 13.3009 27.132 13.8236 27.132V29.19H13.3056C12.6896 29.19 12.2229 29.3347 11.9056 29.624C11.5976 29.9133 11.4436 30.4173 11.4436 31.136V35H9.48358V27.244H11.4436V28.448ZM16.1377 26.32C15.7924 26.32 15.5031 26.2127 15.2697 25.998C15.0457 25.774 14.9337 25.4987 14.9337 25.172C14.9337 24.8453 15.0457 24.5747 15.2697 24.36C15.5031 24.136 15.7924 24.024 16.1377 24.024C16.4831 24.024 16.7677 24.136 16.9917 24.36C17.2251 24.5747 17.3417 24.8453 17.3417 25.172C17.3417 25.4987 17.2251 25.774 16.9917 25.998C16.7677 26.2127 16.4831 26.32 16.1377 26.32ZM17.1037 27.244V35H15.1437V27.244H17.1037ZM18.5362 31.122C18.5362 30.3193 18.6996 29.6193 19.0262 29.022C19.3529 28.4153 19.8056 27.9487 20.3842 27.622C20.9629 27.286 21.6256 27.118 22.3722 27.118C23.3336 27.118 24.1269 27.3607 24.7522 27.846C25.3869 28.322 25.8116 28.994 26.0262 29.862H23.9122C23.8002 29.526 23.6089 29.2647 23.3382 29.078C23.0769 28.882 22.7502 28.784 22.3582 28.784C21.7982 28.784 21.3549 28.9893 21.0282 29.4C20.7016 29.8013 20.5382 30.3753 20.5382 31.122C20.5382 31.8593 20.7016 32.4333 21.0282 32.844C21.3549 33.2453 21.7982 33.446 22.3582 33.446C23.1516 33.446 23.6696 33.0913 23.9122 32.382H26.0262C25.8116 33.222 25.3869 33.8893 24.7522 34.384C24.1176 34.8787 23.3242 35.126 22.3722 35.126C21.6256 35.126 20.9629 34.9627 20.3842 34.636C19.8056 34.3 19.3529 33.8333 19.0262 33.236C18.6996 32.6293 18.5362 31.9247 18.5362 31.122ZM34.6721 30.954C34.6721 31.234 34.6534 31.486 34.6161 31.71H28.9461C28.9928 32.27 29.1888 32.7087 29.5341 33.026C29.8794 33.3433 30.3041 33.502 30.8081 33.502C31.5361 33.502 32.0541 33.1893 32.3621 32.564H34.4761C34.2521 33.3107 33.8228 33.9267 33.1881 34.412C32.5534 34.888 31.7741 35.126 30.8501 35.126C30.1034 35.126 29.4314 34.9627 28.8341 34.636C28.2461 34.3 27.7841 33.8287 27.4481 33.222C27.1214 32.6153 26.9581 31.9153 26.9581 31.122C26.9581 30.3193 27.1214 29.6147 27.4481 29.008C27.7748 28.4013 28.2321 27.9347 28.8201 27.608C29.4081 27.2813 30.0848 27.118 30.8501 27.118C31.5874 27.118 32.2454 27.2767 32.8241 27.594C33.4121 27.9113 33.8648 28.364 34.1821 28.952C34.5088 29.5307 34.6721 30.198 34.6721 30.954ZM32.6421 30.394C32.6328 29.89 32.4508 29.4887 32.0961 29.19C31.7414 28.882 31.3074 28.728 30.7941 28.728C30.3088 28.728 29.8981 28.8773 29.5621 29.176C29.2354 29.4653 29.0348 29.8713 28.9601 30.394H32.6421ZM46.2427 28.168C46.0187 27.7573 45.7107 27.4447 45.3187 27.23C44.9267 27.0153 44.4693 26.908 43.9467 26.908C43.368 26.908 42.8547 27.0387 42.4067 27.3C41.9587 27.5613 41.6087 27.9347 41.3567 28.42C41.1047 28.9053 40.9787 29.4653 40.9787 30.1C40.9787 30.7533 41.1047 31.3227 41.3567 31.808C41.618 32.2933 41.9773 32.6667 42.4347 32.928C42.892 33.1893 43.424 33.32 44.0307 33.32C44.7773 33.32 45.3887 33.124 45.8647 32.732C46.3407 32.3307 46.6533 31.7753 46.8027 31.066H43.4427V29.568H48.7347V31.276C48.604 31.9573 48.324 32.5873 47.8947 33.166C47.4653 33.7447 46.91 34.2113 46.2287 34.566C45.5567 34.9113 44.8007 35.084 43.9607 35.084C43.018 35.084 42.164 34.874 41.3987 34.454C40.6427 34.0247 40.0453 33.432 39.6067 32.676C39.1773 31.92 38.9627 31.0613 38.9627 30.1C38.9627 29.1387 39.1773 28.28 39.6067 27.524C40.0453 26.7587 40.6427 26.166 41.3987 25.746C42.164 25.3167 43.0133 25.102 43.9467 25.102C45.048 25.102 46.0047 25.3727 46.8167 25.914C47.6287 26.446 48.1887 27.1973 48.4967 28.168H46.2427ZM52.1448 28.448C52.3968 28.0373 52.7234 27.7153 53.1248 27.482C53.5354 27.2487 54.0021 27.132 54.5248 27.132V29.19H54.0068C53.3908 29.19 52.9241 29.3347 52.6068 29.624C52.2988 29.9133 52.1448 30.4173 52.1448 31.136V35H50.1848V27.244H52.1448V28.448ZM59.2889 35.126C58.5422 35.126 57.8702 34.9627 57.2729 34.636C56.6756 34.3 56.2042 33.8287 55.8589 33.222C55.5229 32.6153 55.3549 31.9153 55.3549 31.122C55.3549 30.3287 55.5276 29.6287 55.8729 29.022C56.2276 28.4153 56.7082 27.9487 57.3149 27.622C57.9216 27.286 58.5982 27.118 59.3449 27.118C60.0916 27.118 60.7682 27.286 61.3749 27.622C61.9816 27.9487 62.4576 28.4153 62.8029 29.022C63.1576 29.6287 63.3349 30.3287 63.3349 31.122C63.3349 31.9153 63.1529 32.6153 62.7889 33.222C62.4342 33.8287 61.9489 34.3 61.3329 34.636C60.7262 34.9627 60.0449 35.126 59.2889 35.126ZM59.2889 33.418C59.6436 33.418 59.9749 33.334 60.2829 33.166C60.6002 32.9887 60.8522 32.7273 61.0389 32.382C61.2256 32.0367 61.3189 31.6167 61.3189 31.122C61.3189 30.3847 61.1229 29.82 60.7309 29.428C60.3482 29.0267 59.8769 28.826 59.3169 28.826C58.7569 28.826 58.2856 29.0267 57.9029 29.428C57.5296 29.82 57.3429 30.3847 57.3429 31.122C57.3429 31.8593 57.5249 32.4287 57.8889 32.83C58.2622 33.222 58.7289 33.418 59.2889 33.418ZM75.5246 27.244L73.2566 35H71.1426L69.7286 29.582L68.3146 35H66.1866L63.9046 27.244H65.8926L67.2646 33.152L68.7486 27.244H70.8206L72.2766 33.138L73.6486 27.244H75.5246ZM78.8671 28.854V32.606C78.8671 32.8673 78.9278 33.0587 79.0491 33.18C79.1798 33.292 79.3945 33.348 79.6931 33.348H80.6031V35H79.3711C77.7191 35 76.8931 34.1973 76.8931 32.592V28.854H75.9691V27.244H76.8931V25.326H78.8671V27.244H80.6031V28.854H78.8671ZM86.3809 27.132C86.9689 27.132 87.4915 27.2627 87.9489 27.524C88.4062 27.776 88.7609 28.154 89.0129 28.658C89.2742 29.1527 89.4049 29.75 89.4049 30.45V35H87.4449V30.716C87.4449 30.1 87.2909 29.6287 86.9829 29.302C86.6749 28.966 86.2549 28.798 85.7229 28.798C85.1815 28.798 84.7522 28.966 84.4349 29.302C84.1269 29.6287 83.9729 30.1 83.9729 30.716V35H82.0129V24.64H83.9729V28.21C84.2249 27.874 84.5609 27.6127 84.9809 27.426C85.4009 27.23 85.8675 27.132 86.3809 27.132Z"
          fill="#26344E"
        />
        <path
          d="M63.7979 83.1843C45.9375 83.1843 30 93.8857 30 93.8857V157.798H285V69.5751C285 69.5751 276.713 62.0531 263.607 59.6172C239.986 55.2267 236.689 87.2798 215.938 87.2798C200.695 87.2798 199.643 67.2516 179.319 65.426C158.996 63.6004 149.828 109.593 117.066 109.075C92.5232 108.686 77.6 83.1843 63.7979 83.1843Z"
          fill="url(#paint0_linear_15960_152591)"
        />
        <path
          d="M30.4258 93.7485C30.4258 93.7485 45.9383 83.1444 63.7986 83.1444C78.6633 83.1444 92.524 108.604 117.067 108.992C149.829 109.509 158.997 63.5931 179.32 65.4156C199.643 67.2382 200.696 87.2331 215.938 87.233C236.689 87.233 239.986 55.2333 263.608 59.6165C276.713 62.0484 285.001 69.5579 285.001 69.5579"
          stroke="url(#paint1_linear_15960_152591)"
          stroke-width="5"
          stroke-linecap="round"
        />
        <path
          opacity="0.3"
          d="M175.922 65.9759C175.922 56.6004 183.522 49 192.898 49C202.273 49 209.874 56.6004 209.874 65.9759V158.079H175.922V65.9759Z"
          fill="url(#paint2_linear_15960_152591)"
        />
        <g filter="url(#filter0_d_15960_152591)">
          <ellipse
            cx="192.815"
            cy="69.8208"
            rx="9.02974"
            ry="9.02975"
            fill="url(#paint3_linear_15960_152591)"
          />
          <path
            d="M198.845 69.8208C198.845 73.1509 196.145 75.8505 192.815 75.8505C189.485 75.8505 186.785 73.1509 186.785 69.8208C186.785 66.4906 189.485 63.791 192.815 63.791C196.145 63.791 198.845 66.4906 198.845 69.8208Z"
            stroke="white"
            stroke-width="6"
          />
        </g>
        <path opacity="0.1" d="M30 157.799H285" stroke="#454459" />
        <path
          d="M52.84 179.08V186H51.93V180.84L49.63 186H48.99L46.68 180.83V186H45.77V179.08H46.75L49.31 184.8L51.87 179.08H52.84ZM56.7733 186.09C56.2599 186.09 55.7933 185.973 55.3733 185.74C54.9599 185.507 54.6333 185.177 54.3933 184.75C54.1599 184.317 54.0433 183.817 54.0433 183.25C54.0433 182.69 54.1633 182.197 54.4033 181.77C54.6499 181.337 54.9833 181.007 55.4033 180.78C55.8233 180.547 56.2933 180.43 56.8133 180.43C57.3333 180.43 57.8033 180.547 58.2233 180.78C58.6433 181.007 58.9733 181.333 59.2133 181.76C59.4599 182.187 59.5833 182.683 59.5833 183.25C59.5833 183.817 59.4566 184.317 59.2033 184.75C58.9566 185.177 58.6199 185.507 58.1933 185.74C57.7666 185.973 57.2933 186.09 56.7733 186.09ZM56.7733 185.29C57.0999 185.29 57.4066 185.213 57.6933 185.06C57.9799 184.907 58.2099 184.677 58.3833 184.37C58.5633 184.063 58.6533 183.69 58.6533 183.25C58.6533 182.81 58.5666 182.437 58.3933 182.13C58.2199 181.823 57.9933 181.597 57.7133 181.45C57.4333 181.297 57.1299 181.22 56.8033 181.22C56.4699 181.22 56.1633 181.297 55.8833 181.45C55.6099 181.597 55.3899 181.823 55.2233 182.13C55.0566 182.437 54.9733 182.81 54.9733 183.25C54.9733 183.697 55.0533 184.073 55.2133 184.38C55.3799 184.687 55.5999 184.917 55.8733 185.07C56.1466 185.217 56.4466 185.29 56.7733 185.29ZM63.4498 180.42C64.1164 180.42 64.6564 180.623 65.0698 181.03C65.4831 181.43 65.6898 182.01 65.6898 182.77V186H64.7898V182.9C64.7898 182.353 64.6531 181.937 64.3798 181.65C64.1064 181.357 63.7331 181.21 63.2598 181.21C62.7798 181.21 62.3964 181.36 62.1098 181.66C61.8298 181.96 61.6898 182.397 61.6898 182.97V186H60.7798V180.52H61.6898V181.3C61.8698 181.02 62.1131 180.803 62.4198 180.65C62.7331 180.497 63.0764 180.42 63.4498 180.42ZM49.28 194.03V199.18C49.28 199.753 49.1033 200.213 48.75 200.56C48.3967 200.9 47.93 201.07 47.35 201.07C46.7633 201.07 46.2933 200.897 45.94 200.55C45.5867 200.197 45.41 199.717 45.41 199.11H46.32C46.3267 199.45 46.4133 199.727 46.58 199.94C46.7533 200.153 47.01 200.26 47.35 200.26C47.69 200.26 47.9433 200.16 48.11 199.96C48.2767 199.753 48.36 199.493 48.36 199.18V194.03H49.28ZM55.9327 195.52V201H55.0227V200.19C54.8494 200.47 54.6061 200.69 54.2927 200.85C53.9861 201.003 53.6461 201.08 53.2727 201.08C52.8461 201.08 52.4627 200.993 52.1227 200.82C51.7827 200.64 51.5127 200.373 51.3127 200.02C51.1194 199.667 51.0227 199.237 51.0227 198.73V195.52H51.9227V198.61C51.9227 199.15 52.0594 199.567 52.3327 199.86C52.6061 200.147 52.9794 200.29 53.4527 200.29C53.9394 200.29 54.3227 200.14 54.6027 199.84C54.8827 199.54 55.0227 199.103 55.0227 198.53V195.52H55.9327ZM60.1392 195.42C60.8059 195.42 61.3459 195.623 61.7592 196.03C62.1726 196.43 62.3792 197.01 62.3792 197.77V201H61.4792V197.9C61.4792 197.353 61.3426 196.937 61.0692 196.65C60.7959 196.357 60.4226 196.21 59.9492 196.21C59.4692 196.21 59.0859 196.36 58.7992 196.66C58.5192 196.96 58.3792 197.397 58.3792 197.97V201H57.4692V195.52H58.3792V196.3C58.5592 196.02 58.8026 195.803 59.1092 195.65C59.4226 195.497 59.7659 195.42 60.1392 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M3.38 147.6V146.77H5.26V154H4.34V147.6H3.38ZM6.82313 150.31C6.82313 149.163 7.00979 148.27 7.38313 147.63C7.75646 146.983 8.40979 146.66 9.34313 146.66C10.2698 146.66 10.9198 146.983 11.2931 147.63C11.6665 148.27 11.8531 149.163 11.8531 150.31C11.8531 151.477 11.6665 152.383 11.2931 153.03C10.9198 153.677 10.2698 154 9.34313 154C8.40979 154 7.75646 153.677 7.38313 153.03C7.00979 152.383 6.82313 151.477 6.82313 150.31ZM10.9531 150.31C10.9531 149.73 10.9131 149.24 10.8331 148.84C10.7598 148.433 10.6031 148.107 10.3631 147.86C10.1298 147.613 9.78979 147.49 9.34313 147.49C8.88979 147.49 8.54313 147.613 8.30313 147.86C8.06979 148.107 7.91313 148.433 7.83313 148.84C7.75979 149.24 7.72313 149.73 7.72313 150.31C7.72313 150.91 7.75979 151.413 7.83313 151.82C7.91313 152.227 8.06979 152.553 8.30313 152.8C8.54313 153.047 8.88979 153.17 9.34313 153.17C9.78979 153.17 10.1298 153.047 10.3631 152.8C10.6031 152.553 10.7598 152.227 10.8331 151.82C10.9131 151.413 10.9531 150.91 10.9531 150.31Z"
          fill="#C4C4C4"
        />
        <path
          d="M0.51 134.27C1.35667 133.59 2.02 133.033 2.5 132.6C2.98 132.16 3.38333 131.703 3.71 131.23C4.04333 130.75 4.21 130.28 4.21 129.82C4.21 129.387 4.10333 129.047 3.89 128.8C3.68333 128.547 3.34667 128.42 2.88 128.42C2.42667 128.42 2.07333 128.563 1.82 128.85C1.57333 129.13 1.44 129.507 1.42 129.98H0.54C0.566667 129.233 0.793333 128.657 1.22 128.25C1.64667 127.843 2.19667 127.64 2.87 127.64C3.55667 127.64 4.1 127.83 4.5 128.21C4.90667 128.59 5.11 129.113 5.11 129.78C5.11 130.333 4.94333 130.873 4.61 131.4C4.28333 131.92 3.91 132.38 3.49 132.78C3.07 133.173 2.53333 133.633 1.88 134.16H5.32V134.92H0.51V134.27ZM6.37195 131.31C6.37195 130.163 6.55862 129.27 6.93195 128.63C7.30529 127.983 7.95862 127.66 8.89195 127.66C9.81862 127.66 10.4686 127.983 10.842 128.63C11.2153 129.27 11.402 130.163 11.402 131.31C11.402 132.477 11.2153 133.383 10.842 134.03C10.4686 134.677 9.81862 135 8.89195 135C7.95862 135 7.30529 134.677 6.93195 134.03C6.55862 133.383 6.37195 132.477 6.37195 131.31ZM10.502 131.31C10.502 130.73 10.462 130.24 10.382 129.84C10.3086 129.433 10.152 129.107 9.91195 128.86C9.67862 128.613 9.33862 128.49 8.89195 128.49C8.43862 128.49 8.09195 128.613 7.85195 128.86C7.61862 129.107 7.46195 129.433 7.38195 129.84C7.30862 130.24 7.27195 130.73 7.27195 131.31C7.27195 131.91 7.30862 132.413 7.38195 132.82C7.46195 133.227 7.61862 133.553 7.85195 133.8C8.09195 134.047 8.43862 134.17 8.89195 134.17C9.33862 134.17 9.67862 134.047 9.91195 133.8C10.152 133.553 10.3086 133.227 10.382 132.82C10.462 132.413 10.502 131.91 10.502 131.31Z"
          fill="#C4C4C4"
        />
        <path
          d="M0.6 110.59C0.646667 109.977 0.883333 109.497 1.31 109.15C1.73667 108.803 2.29 108.63 2.97 108.63C3.42333 108.63 3.81333 108.713 4.14 108.88C4.47333 109.04 4.72333 109.26 4.89 109.54C5.06333 109.82 5.15 110.137 5.15 110.49C5.15 110.903 5.03 111.26 4.79 111.56C4.55667 111.86 4.25 112.053 3.87 112.14V112.19C4.30333 112.297 4.64667 112.507 4.9 112.82C5.15333 113.133 5.28 113.543 5.28 114.05C5.28 114.43 5.19333 114.773 5.02 115.08C4.84667 115.38 4.58667 115.617 4.24 115.79C3.89333 115.963 3.47667 116.05 2.99 116.05C2.28333 116.05 1.70333 115.867 1.25 115.5C0.796667 115.127 0.543333 114.6 0.49 113.92H1.37C1.41667 114.32 1.58 114.647 1.86 114.9C2.14 115.153 2.51333 115.28 2.98 115.28C3.44667 115.28 3.8 115.16 4.04 114.92C4.28667 114.673 4.41 114.357 4.41 113.97C4.41 113.47 4.24333 113.11 3.91 112.89C3.57667 112.67 3.07333 112.56 2.4 112.56H2.17V111.8H2.41C3.02333 111.793 3.48667 111.693 3.8 111.5C4.11333 111.3 4.27 110.993 4.27 110.58C4.27 110.227 4.15333 109.943 3.92 109.73C3.69333 109.517 3.36667 109.41 2.94 109.41C2.52667 109.41 2.19333 109.517 1.94 109.73C1.68667 109.943 1.53667 110.23 1.49 110.59H0.6ZM6.50867 112.31C6.50867 111.163 6.69534 110.27 7.06867 109.63C7.44201 108.983 8.09534 108.66 9.02867 108.66C9.95534 108.66 10.6053 108.983 10.9787 109.63C11.352 110.27 11.5387 111.163 11.5387 112.31C11.5387 113.477 11.352 114.383 10.9787 115.03C10.6053 115.677 9.95534 116 9.02867 116C8.09534 116 7.44201 115.677 7.06867 115.03C6.69534 114.383 6.50867 113.477 6.50867 112.31ZM10.6387 112.31C10.6387 111.73 10.5987 111.24 10.5187 110.84C10.4453 110.433 10.2887 110.107 10.0487 109.86C9.81534 109.613 9.47534 109.49 9.02867 109.49C8.57534 109.49 8.22867 109.613 7.98867 109.86C7.75534 110.107 7.59867 110.433 7.51867 110.84C7.44534 111.24 7.40867 111.73 7.40867 112.31C7.40867 112.91 7.44534 113.413 7.51867 113.82C7.59867 114.227 7.75534 114.553 7.98867 114.8C8.22867 115.047 8.57534 115.17 9.02867 115.17C9.47534 115.17 9.81534 115.047 10.0487 114.8C10.2887 114.553 10.4453 114.227 10.5187 113.82C10.5987 113.413 10.6387 112.91 10.6387 112.31Z"
          fill="#C4C4C4"
        />
        <path
          d="M0.4 96.39V95.7L3.91 90.84H5V95.6H6V96.39H5V98H4.1V96.39H0.4ZM4.14 91.79L1.45 95.6H4.14V91.79ZM6.90906 94.31C6.90906 93.1633 7.09573 92.27 7.46906 91.63C7.8424 90.9833 8.49573 90.66 9.42906 90.66C10.3557 90.66 11.0057 90.9833 11.3791 91.63C11.7524 92.27 11.9391 93.1633 11.9391 94.31C11.9391 95.4767 11.7524 96.3833 11.3791 97.03C11.0057 97.6767 10.3557 98 9.42906 98C8.49573 98 7.8424 97.6767 7.46906 97.03C7.09573 96.3833 6.90906 95.4767 6.90906 94.31ZM11.0391 94.31C11.0391 93.73 10.9991 93.24 10.9191 92.84C10.8457 92.4333 10.6891 92.1067 10.4491 91.86C10.2157 91.6133 9.87573 91.49 9.42906 91.49C8.97573 91.49 8.62906 91.6133 8.38906 91.86C8.15573 92.1067 7.99906 92.4333 7.91906 92.84C7.84573 93.24 7.80906 93.73 7.80906 94.31C7.80906 94.91 7.84573 95.4133 7.91906 95.82C7.99906 96.2267 8.15573 96.5533 8.38906 96.8C8.62906 97.0467 8.97573 97.17 9.42906 97.17C9.87573 97.17 10.2157 97.0467 10.4491 96.8C10.6891 96.5533 10.8457 96.2267 10.9191 95.82C10.9991 95.4133 11.0391 94.91 11.0391 94.31Z"
          fill="#C4C4C4"
        />
        <path
          d="M5.23 72.56H1.72V74.84C1.87333 74.6267 2.1 74.4533 2.4 74.32C2.7 74.18 3.02333 74.11 3.37 74.11C3.92333 74.11 4.37333 74.2267 4.72 74.46C5.06667 74.6867 5.31333 74.9833 5.46 75.35C5.61333 75.71 5.69 76.0933 5.69 76.5C5.69 76.98 5.6 77.41 5.42 77.79C5.24 78.17 4.96333 78.47 4.59 78.69C4.22333 78.91 3.76667 79.02 3.22 79.02C2.52 79.02 1.95333 78.84 1.52 78.48C1.08667 78.12 0.823333 77.64 0.73 77.04H1.62C1.70667 77.42 1.89 77.7167 2.17 77.93C2.45 78.1433 2.80333 78.25 3.23 78.25C3.75667 78.25 4.15333 78.0933 4.42 77.78C4.68667 77.46 4.82 77.04 4.82 76.52C4.82 76 4.68667 75.6 4.42 75.32C4.15333 75.0333 3.76 74.89 3.24 74.89C2.88667 74.89 2.57667 74.9767 2.31 75.15C2.05 75.3167 1.86 75.5467 1.74 75.84H0.88V71.76H5.23V72.56ZM6.8993 75.31C6.8993 74.1633 7.08596 73.27 7.4593 72.63C7.83263 71.9833 8.48596 71.66 9.4193 71.66C10.346 71.66 10.996 71.9833 11.3693 72.63C11.7426 73.27 11.9293 74.1633 11.9293 75.31C11.9293 76.4767 11.7426 77.3833 11.3693 78.03C10.996 78.6767 10.346 79 9.4193 79C8.48596 79 7.83263 78.6767 7.4593 78.03C7.08596 77.3833 6.8993 76.4767 6.8993 75.31ZM11.0293 75.31C11.0293 74.73 10.9893 74.24 10.9093 73.84C10.836 73.4333 10.6793 73.1067 10.4393 72.86C10.206 72.6133 9.86596 72.49 9.4193 72.49C8.96596 72.49 8.6193 72.6133 8.3793 72.86C8.14596 73.1067 7.9893 73.4333 7.9093 73.84C7.83596 74.24 7.7993 74.73 7.7993 75.31C7.7993 75.91 7.83596 76.4133 7.9093 76.82C7.9893 77.2267 8.14596 77.5533 8.3793 77.8C8.6193 78.0467 8.96596 78.17 9.4193 78.17C9.86596 78.17 10.206 78.0467 10.4393 77.8C10.6793 77.5533 10.836 77.2267 10.9093 76.82C10.9893 76.4133 11.0293 75.91 11.0293 75.31Z"
          fill="#C4C4C4"
        />
        <path
          d="M4.65 56.49C4.50333 55.75 4.04667 55.38 3.28 55.38C2.68667 55.38 2.24333 55.61 1.95 56.07C1.65667 56.5233 1.51333 57.2733 1.52 58.32C1.67333 57.9733 1.92667 57.7033 2.28 57.51C2.64 57.31 3.04 57.21 3.48 57.21C4.16667 57.21 4.71333 57.4233 5.12 57.85C5.53333 58.2767 5.74 58.8667 5.74 59.62C5.74 60.0733 5.65 60.48 5.47 60.84C5.29667 61.2 5.03 61.4867 4.67 61.7C4.31667 61.9133 3.88667 62.02 3.38 62.02C2.69333 62.02 2.15667 61.8667 1.77 61.56C1.38333 61.2533 1.11333 60.83 0.96 60.29C0.806667 59.75 0.73 59.0833 0.73 58.29C0.73 55.8433 1.58333 54.62 3.29 54.62C3.94333 54.62 4.45667 54.7967 4.83 55.15C5.20333 55.5033 5.42333 55.95 5.49 56.49H4.65ZM3.29 57.98C3.00333 57.98 2.73333 58.04 2.48 58.16C2.22667 58.2733 2.02 58.45 1.86 58.69C1.70667 58.9233 1.63 59.21 1.63 59.55C1.63 60.0567 1.77667 60.47 2.07 60.79C2.36333 61.1033 2.78333 61.26 3.33 61.26C3.79667 61.26 4.16667 61.1167 4.44 60.83C4.72 60.5367 4.86 60.1433 4.86 59.65C4.86 59.13 4.72667 58.7233 4.46 58.43C4.19333 58.13 3.80333 57.98 3.29 57.98ZM6.96766 58.31C6.96766 57.1633 7.15432 56.27 7.52766 55.63C7.90099 54.9833 8.55432 54.66 9.48766 54.66C10.4143 54.66 11.0643 54.9833 11.4377 55.63C11.811 56.27 11.9977 57.1633 11.9977 58.31C11.9977 59.4767 11.811 60.3833 11.4377 61.03C11.0643 61.6767 10.4143 62 9.48766 62C8.55432 62 7.90099 61.6767 7.52766 61.03C7.15432 60.3833 6.96766 59.4767 6.96766 58.31ZM11.0977 58.31C11.0977 57.73 11.0577 57.24 10.9777 56.84C10.9043 56.4333 10.7477 56.1067 10.5077 55.86C10.2743 55.6133 9.93432 55.49 9.48766 55.49C9.03432 55.49 8.68766 55.6133 8.44766 55.86C8.21432 56.1067 8.05766 56.4333 7.97766 56.84C7.90432 57.24 7.86766 57.73 7.86766 58.31C7.86766 58.91 7.90432 59.4133 7.97766 59.82C8.05766 60.2267 8.21432 60.5533 8.44766 60.8C8.68766 61.0467 9.03432 61.17 9.48766 61.17C9.93432 61.17 10.2743 61.0467 10.5077 60.8C10.7477 60.5533 10.9043 60.2267 10.9777 59.82C11.0577 59.4133 11.0977 58.91 11.0977 58.31Z"
          fill="#C4C4C4"
        />
        <path
          d="M86.06 179.03V179.77H84.16V186H83.25V179.77H81.34V179.03H86.06ZM92.0402 180.52V186H91.1302V185.19C90.9568 185.47 90.7135 185.69 90.4002 185.85C90.0935 186.003 89.7535 186.08 89.3802 186.08C88.9535 186.08 88.5702 185.993 88.2302 185.82C87.8902 185.64 87.6202 185.373 87.4202 185.02C87.2268 184.667 87.1302 184.237 87.1302 183.73V180.52H88.0302V183.61C88.0302 184.15 88.1668 184.567 88.4402 184.86C88.7135 185.147 89.0868 185.29 89.5602 185.29C90.0468 185.29 90.4302 185.14 90.7102 184.84C90.9902 184.54 91.1302 184.103 91.1302 183.53V180.52H92.0402ZM98.5766 183.05C98.5766 183.223 98.5666 183.407 98.5466 183.6H94.1666C94.2 184.14 94.3833 184.563 94.7166 184.87C95.0566 185.17 95.4666 185.32 95.9466 185.32C96.34 185.32 96.6666 185.23 96.9266 185.05C97.1933 184.863 97.38 184.617 97.4866 184.31H98.4666C98.32 184.837 98.0266 185.267 97.5866 185.6C97.1466 185.927 96.6 186.09 95.9466 186.09C95.4266 186.09 94.96 185.973 94.5466 185.74C94.14 185.507 93.82 185.177 93.5866 184.75C93.3533 184.317 93.2366 183.817 93.2366 183.25C93.2366 182.683 93.35 182.187 93.5766 181.76C93.8033 181.333 94.12 181.007 94.5266 180.78C94.94 180.547 95.4133 180.43 95.9466 180.43C96.4666 180.43 96.9266 180.543 97.3266 180.77C97.7266 180.997 98.0333 181.31 98.2466 181.71C98.4666 182.103 98.5766 182.55 98.5766 183.05ZM97.6366 182.86C97.6366 182.513 97.56 182.217 97.4066 181.97C97.2533 181.717 97.0433 181.527 96.7766 181.4C96.5166 181.267 96.2266 181.2 95.9066 181.2C95.4466 181.2 95.0533 181.347 94.7266 181.64C94.4066 181.933 94.2233 182.34 94.1766 182.86H97.6366ZM85.28 194.03V199.18C85.28 199.753 85.1033 200.213 84.75 200.56C84.3967 200.9 83.93 201.07 83.35 201.07C82.7633 201.07 82.2933 200.897 81.94 200.55C81.5867 200.197 81.41 199.717 81.41 199.11H82.32C82.3267 199.45 82.4133 199.727 82.58 199.94C82.7533 200.153 83.01 200.26 83.35 200.26C83.69 200.26 83.9433 200.16 84.11 199.96C84.2767 199.753 84.36 199.493 84.36 199.18V194.03H85.28ZM91.9327 195.52V201H91.0227V200.19C90.8494 200.47 90.6061 200.69 90.2927 200.85C89.9861 201.003 89.6461 201.08 89.2727 201.08C88.8461 201.08 88.4627 200.993 88.1227 200.82C87.7827 200.64 87.5127 200.373 87.3127 200.02C87.1194 199.667 87.0227 199.237 87.0227 198.73V195.52H87.9227V198.61C87.9227 199.15 88.0594 199.567 88.3327 199.86C88.6061 200.147 88.9794 200.29 89.4527 200.29C89.9394 200.29 90.3227 200.14 90.6027 199.84C90.8827 199.54 91.0227 199.103 91.0227 198.53V195.52H91.9327ZM96.1392 195.42C96.8059 195.42 97.3459 195.623 97.7592 196.03C98.1726 196.43 98.3792 197.01 98.3792 197.77V201H97.4792V197.9C97.4792 197.353 97.3426 196.937 97.0692 196.65C96.7959 196.357 96.4226 196.21 95.9492 196.21C95.4692 196.21 95.0859 196.36 94.7992 196.66C94.5192 196.96 94.3792 197.397 94.3792 197.97V201H93.4692V195.52H94.3792V196.3C94.5592 196.02 94.8026 195.803 95.1092 195.65C95.4226 195.497 95.7659 195.42 96.1392 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M125.53 179.03L123.51 186H122.49L120.87 180.39L119.19 186L118.18 186.01L116.23 179.03H117.2L118.72 184.94L120.4 179.03H121.42L123.02 184.92L124.55 179.03H125.53ZM131.526 183.05C131.526 183.223 131.516 183.407 131.496 183.6H127.116C127.149 184.14 127.333 184.563 127.666 184.87C128.006 185.17 128.416 185.32 128.896 185.32C129.289 185.32 129.616 185.23 129.876 185.05C130.143 184.863 130.329 184.617 130.436 184.31H131.416C131.269 184.837 130.976 185.267 130.536 185.6C130.096 185.927 129.549 186.09 128.896 186.09C128.376 186.09 127.909 185.973 127.496 185.74C127.089 185.507 126.769 185.177 126.536 184.75C126.303 184.317 126.186 183.817 126.186 183.25C126.186 182.683 126.299 182.187 126.526 181.76C126.753 181.333 127.069 181.007 127.476 180.78C127.889 180.547 128.363 180.43 128.896 180.43C129.416 180.43 129.876 180.543 130.276 180.77C130.676 180.997 130.983 181.31 131.196 181.71C131.416 182.103 131.526 182.55 131.526 183.05ZM130.586 182.86C130.586 182.513 130.509 182.217 130.356 181.97C130.203 181.717 129.993 181.527 129.726 181.4C129.466 181.267 129.176 181.2 128.856 181.2C128.396 181.2 128.003 181.347 127.676 181.64C127.356 181.933 127.173 182.34 127.126 182.86H130.586ZM132.387 183.24C132.387 182.68 132.5 182.19 132.727 181.77C132.954 181.343 133.264 181.013 133.657 180.78C134.057 180.547 134.504 180.43 134.997 180.43C135.424 180.43 135.82 180.53 136.187 180.73C136.554 180.923 136.834 181.18 137.027 181.5V178.6H137.947V186H137.027V184.97C136.847 185.297 136.58 185.567 136.227 185.78C135.874 185.987 135.46 186.09 134.987 186.09C134.5 186.09 134.057 185.97 133.657 185.73C133.264 185.49 132.954 185.153 132.727 184.72C132.5 184.287 132.387 183.793 132.387 183.24ZM137.027 183.25C137.027 182.837 136.944 182.477 136.777 182.17C136.61 181.863 136.384 181.63 136.097 181.47C135.817 181.303 135.507 181.22 135.167 181.22C134.827 181.22 134.517 181.3 134.237 181.46C133.957 181.62 133.734 181.853 133.567 182.16C133.4 182.467 133.317 182.827 133.317 183.24C133.317 183.66 133.4 184.027 133.567 184.34C133.734 184.647 133.957 184.883 134.237 185.05C134.517 185.21 134.827 185.29 135.167 185.29C135.507 185.29 135.817 185.21 136.097 185.05C136.384 184.883 136.61 184.647 136.777 184.34C136.944 184.027 137.027 183.663 137.027 183.25ZM120.28 194.03V199.18C120.28 199.753 120.103 200.213 119.75 200.56C119.397 200.9 118.93 201.07 118.35 201.07C117.763 201.07 117.293 200.897 116.94 200.55C116.587 200.197 116.41 199.717 116.41 199.11H117.32C117.327 199.45 117.413 199.727 117.58 199.94C117.753 200.153 118.01 200.26 118.35 200.26C118.69 200.26 118.943 200.16 119.11 199.96C119.277 199.753 119.36 199.493 119.36 199.18V194.03H120.28ZM126.933 195.52V201H126.023V200.19C125.849 200.47 125.606 200.69 125.293 200.85C124.986 201.003 124.646 201.08 124.273 201.08C123.846 201.08 123.463 200.993 123.123 200.82C122.783 200.64 122.513 200.373 122.313 200.02C122.119 199.667 122.023 199.237 122.023 198.73V195.52H122.923V198.61C122.923 199.15 123.059 199.567 123.333 199.86C123.606 200.147 123.979 200.29 124.453 200.29C124.939 200.29 125.323 200.14 125.603 199.84C125.883 199.54 126.023 199.103 126.023 198.53V195.52H126.933ZM131.139 195.42C131.806 195.42 132.346 195.623 132.759 196.03C133.173 196.43 133.379 197.01 133.379 197.77V201H132.479V197.9C132.479 197.353 132.343 196.937 132.069 196.65C131.796 196.357 131.423 196.21 130.949 196.21C130.469 196.21 130.086 196.36 129.799 196.66C129.519 196.96 129.379 197.397 129.379 197.97V201H128.469V195.52H129.379V196.3C129.559 196.02 129.803 195.803 130.109 195.65C130.423 195.497 130.766 195.42 131.139 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M158.06 179.03V179.77H156.16V186H155.25V179.77H153.34V179.03H158.06ZM161.9 180.42C162.313 180.42 162.687 180.51 163.02 180.69C163.353 180.863 163.613 181.127 163.8 181.48C163.993 181.833 164.09 182.263 164.09 182.77V186H163.19V182.9C163.19 182.353 163.053 181.937 162.78 181.65C162.507 181.357 162.133 181.21 161.66 181.21C161.18 181.21 160.797 181.36 160.51 181.66C160.23 181.96 160.09 182.397 160.09 182.97V186H159.18V178.6H160.09V181.3C160.27 181.02 160.517 180.803 160.83 180.65C161.15 180.497 161.507 180.42 161.9 180.42ZM166.487 181.41C166.647 181.097 166.873 180.853 167.167 180.68C167.467 180.507 167.83 180.42 168.257 180.42V181.36H168.017C166.997 181.36 166.487 181.913 166.487 183.02V186H165.577V180.52H166.487V181.41ZM157.28 194.03V199.18C157.28 199.753 157.103 200.213 156.75 200.56C156.397 200.9 155.93 201.07 155.35 201.07C154.763 201.07 154.293 200.897 153.94 200.55C153.587 200.197 153.41 199.717 153.41 199.11H154.32C154.327 199.45 154.413 199.727 154.58 199.94C154.753 200.153 155.01 200.26 155.35 200.26C155.69 200.26 155.943 200.16 156.11 199.96C156.277 199.753 156.36 199.493 156.36 199.18V194.03H157.28ZM163.933 195.52V201H163.023V200.19C162.849 200.47 162.606 200.69 162.293 200.85C161.986 201.003 161.646 201.08 161.273 201.08C160.846 201.08 160.463 200.993 160.123 200.82C159.783 200.64 159.513 200.373 159.313 200.02C159.119 199.667 159.023 199.237 159.023 198.73V195.52H159.923V198.61C159.923 199.15 160.059 199.567 160.333 199.86C160.606 200.147 160.979 200.29 161.453 200.29C161.939 200.29 162.323 200.14 162.603 199.84C162.883 199.54 163.023 199.103 163.023 198.53V195.52H163.933ZM168.139 195.42C168.806 195.42 169.346 195.623 169.759 196.03C170.173 196.43 170.379 197.01 170.379 197.77V201H169.479V197.9C169.479 197.353 169.343 196.937 169.069 196.65C168.796 196.357 168.423 196.21 167.949 196.21C167.469 196.21 167.086 196.36 166.799 196.66C166.519 196.96 166.379 197.397 166.379 197.97V201H165.469V195.52H166.379V196.3C166.559 196.02 166.803 195.803 167.109 195.65C167.423 195.497 167.766 195.42 168.139 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M193.71 179.03V179.77H190.68V182.12H193.14V182.86H190.68V186H189.77V179.03H193.71ZM195.719 181.41C195.879 181.097 196.106 180.853 196.399 180.68C196.699 180.507 197.062 180.42 197.489 180.42V181.36H197.249C196.229 181.36 195.719 181.913 195.719 183.02V186H194.809V180.52H195.719V181.41ZM199.01 179.63C198.836 179.63 198.69 179.57 198.57 179.45C198.45 179.33 198.39 179.183 198.39 179.01C198.39 178.837 198.45 178.69 198.57 178.57C198.69 178.45 198.836 178.39 199.01 178.39C199.176 178.39 199.316 178.45 199.43 178.57C199.55 178.69 199.61 178.837 199.61 179.01C199.61 179.183 199.55 179.33 199.43 179.45C199.316 179.57 199.176 179.63 199.01 179.63ZM199.45 180.52V186H198.54V180.52H199.45ZM193.28 194.03V199.18C193.28 199.753 193.103 200.213 192.75 200.56C192.397 200.9 191.93 201.07 191.35 201.07C190.763 201.07 190.293 200.897 189.94 200.55C189.587 200.197 189.41 199.717 189.41 199.11H190.32C190.327 199.45 190.413 199.727 190.58 199.94C190.753 200.153 191.01 200.26 191.35 200.26C191.69 200.26 191.943 200.16 192.11 199.96C192.277 199.753 192.36 199.493 192.36 199.18V194.03H193.28ZM199.933 195.52V201H199.023V200.19C198.849 200.47 198.606 200.69 198.293 200.85C197.986 201.003 197.646 201.08 197.273 201.08C196.846 201.08 196.463 200.993 196.123 200.82C195.783 200.64 195.513 200.373 195.313 200.02C195.119 199.667 195.023 199.237 195.023 198.73V195.52H195.923V198.61C195.923 199.15 196.059 199.567 196.333 199.86C196.606 200.147 196.979 200.29 197.453 200.29C197.939 200.29 198.323 200.14 198.603 199.84C198.883 199.54 199.023 199.103 199.023 198.53V195.52H199.933ZM204.139 195.42C204.806 195.42 205.346 195.623 205.759 196.03C206.173 196.43 206.379 197.01 206.379 197.77V201H205.479V197.9C205.479 197.353 205.343 196.937 205.069 196.65C204.796 196.357 204.423 196.21 203.949 196.21C203.469 196.21 203.086 196.36 202.799 196.66C202.519 196.96 202.379 197.397 202.379 197.97V201H201.469V195.52H202.379V196.3C202.559 196.02 202.803 195.803 203.109 195.65C203.423 195.497 203.766 195.42 204.139 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M227.98 186.07C227.52 186.07 227.107 185.99 226.74 185.83C226.38 185.663 226.097 185.437 225.89 185.15C225.683 184.857 225.577 184.52 225.57 184.14H226.54C226.573 184.467 226.707 184.743 226.94 184.97C227.18 185.19 227.527 185.3 227.98 185.3C228.413 185.3 228.753 185.193 229 184.98C229.253 184.76 229.38 184.48 229.38 184.14C229.38 183.873 229.307 183.657 229.16 183.49C229.013 183.323 228.83 183.197 228.61 183.11C228.39 183.023 228.093 182.93 227.72 182.83C227.26 182.71 226.89 182.59 226.61 182.47C226.337 182.35 226.1 182.163 225.9 181.91C225.707 181.65 225.61 181.303 225.61 180.87C225.61 180.49 225.707 180.153 225.9 179.86C226.093 179.567 226.363 179.34 226.71 179.18C227.063 179.02 227.467 178.94 227.92 178.94C228.573 178.94 229.107 179.103 229.52 179.43C229.94 179.757 230.177 180.19 230.23 180.73H229.23C229.197 180.463 229.057 180.23 228.81 180.03C228.563 179.823 228.237 179.72 227.83 179.72C227.45 179.72 227.14 179.82 226.9 180.02C226.66 180.213 226.54 180.487 226.54 180.84C226.54 181.093 226.61 181.3 226.75 181.46C226.897 181.62 227.073 181.743 227.28 181.83C227.493 181.91 227.79 182.003 228.17 182.11C228.63 182.237 229 182.363 229.28 182.49C229.56 182.61 229.8 182.8 230 183.06C230.2 183.313 230.3 183.66 230.3 184.1C230.3 184.44 230.21 184.76 230.03 185.06C229.85 185.36 229.583 185.603 229.23 185.79C228.877 185.977 228.46 186.07 227.98 186.07ZM231.299 183.24C231.299 182.68 231.412 182.19 231.639 181.77C231.866 181.343 232.176 181.013 232.569 180.78C232.969 180.547 233.412 180.43 233.899 180.43C234.379 180.43 234.796 180.533 235.149 180.74C235.502 180.947 235.766 181.207 235.939 181.52V180.52H236.859V186H235.939V184.98C235.759 185.3 235.489 185.567 235.129 185.78C234.776 185.987 234.362 186.09 233.889 186.09C233.402 186.09 232.962 185.97 232.569 185.73C232.176 185.49 231.866 185.153 231.639 184.72C231.412 184.287 231.299 183.793 231.299 183.24ZM235.939 183.25C235.939 182.837 235.856 182.477 235.689 182.17C235.522 181.863 235.296 181.63 235.009 181.47C234.729 181.303 234.419 181.22 234.079 181.22C233.739 181.22 233.429 181.3 233.149 181.46C232.869 181.62 232.646 181.853 232.479 182.16C232.312 182.467 232.229 182.827 232.229 183.24C232.229 183.66 232.312 184.027 232.479 184.34C232.646 184.647 232.869 184.883 233.149 185.05C233.429 185.21 233.739 185.29 234.079 185.29C234.419 185.29 234.729 185.21 235.009 185.05C235.296 184.883 235.522 184.647 235.689 184.34C235.856 184.027 235.939 183.663 235.939 183.25ZM239.507 181.27V184.5C239.507 184.767 239.564 184.957 239.677 185.07C239.79 185.177 239.987 185.23 240.267 185.23H240.937V186H240.117C239.61 186 239.23 185.883 238.977 185.65C238.724 185.417 238.597 185.033 238.597 184.5V181.27H237.887V180.52H238.597V179.14H239.507V180.52H240.937V181.27H239.507ZM229.28 194.03V199.18C229.28 199.753 229.103 200.213 228.75 200.56C228.397 200.9 227.93 201.07 227.35 201.07C226.763 201.07 226.293 200.897 225.94 200.55C225.587 200.197 225.41 199.717 225.41 199.11H226.32C226.327 199.45 226.413 199.727 226.58 199.94C226.753 200.153 227.01 200.26 227.35 200.26C227.69 200.26 227.943 200.16 228.11 199.96C228.277 199.753 228.36 199.493 228.36 199.18V194.03H229.28ZM235.933 195.52V201H235.023V200.19C234.849 200.47 234.606 200.69 234.293 200.85C233.986 201.003 233.646 201.08 233.273 201.08C232.846 201.08 232.463 200.993 232.123 200.82C231.783 200.64 231.513 200.373 231.313 200.02C231.119 199.667 231.023 199.237 231.023 198.73V195.52H231.923V198.61C231.923 199.15 232.059 199.567 232.333 199.86C232.606 200.147 232.979 200.29 233.453 200.29C233.939 200.29 234.323 200.14 234.603 199.84C234.883 199.54 235.023 199.103 235.023 198.53V195.52H235.933ZM240.139 195.42C240.806 195.42 241.346 195.623 241.759 196.03C242.173 196.43 242.379 197.01 242.379 197.77V201H241.479V197.9C241.479 197.353 241.343 196.937 241.069 196.65C240.796 196.357 240.423 196.21 239.949 196.21C239.469 196.21 239.086 196.36 238.799 196.66C238.519 196.96 238.379 197.397 238.379 197.97V201H237.469V195.52H238.379V196.3C238.559 196.02 238.803 195.803 239.109 195.65C239.423 195.497 239.766 195.42 240.139 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M21 59V166H285"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M18 151H21"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M58 170L58 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M94 170L94 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M129 170L129 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M166 170L166 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M202 170L202 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M238 170L238 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M18 132H21"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M18 113H21"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M18 95H21"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M18 76H21"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M18 59H21"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <path
          d="M263.98 186.07C263.52 186.07 263.107 185.99 262.74 185.83C262.38 185.663 262.097 185.437 261.89 185.15C261.683 184.857 261.577 184.52 261.57 184.14H262.54C262.573 184.467 262.707 184.743 262.94 184.97C263.18 185.19 263.527 185.3 263.98 185.3C264.413 185.3 264.753 185.193 265 184.98C265.253 184.76 265.38 184.48 265.38 184.14C265.38 183.873 265.307 183.657 265.16 183.49C265.013 183.323 264.83 183.197 264.61 183.11C264.39 183.023 264.093 182.93 263.72 182.83C263.26 182.71 262.89 182.59 262.61 182.47C262.337 182.35 262.1 182.163 261.9 181.91C261.707 181.65 261.61 181.303 261.61 180.87C261.61 180.49 261.707 180.153 261.9 179.86C262.093 179.567 262.363 179.34 262.71 179.18C263.063 179.02 263.467 178.94 263.92 178.94C264.573 178.94 265.107 179.103 265.52 179.43C265.94 179.757 266.177 180.19 266.23 180.73H265.23C265.197 180.463 265.057 180.23 264.81 180.03C264.563 179.823 264.237 179.72 263.83 179.72C263.45 179.72 263.14 179.82 262.9 180.02C262.66 180.213 262.54 180.487 262.54 180.84C262.54 181.093 262.61 181.3 262.75 181.46C262.897 181.62 263.073 181.743 263.28 181.83C263.493 181.91 263.79 182.003 264.17 182.11C264.63 182.237 265 182.363 265.28 182.49C265.56 182.61 265.8 182.8 266 183.06C266.2 183.313 266.3 183.66 266.3 184.1C266.3 184.44 266.21 184.76 266.03 185.06C265.85 185.36 265.583 185.603 265.23 185.79C264.877 185.977 264.46 186.07 263.98 186.07ZM272.499 180.52V186H271.589V185.19C271.416 185.47 271.172 185.69 270.859 185.85C270.552 186.003 270.212 186.08 269.839 186.08C269.412 186.08 269.029 185.993 268.689 185.82C268.349 185.64 268.079 185.373 267.879 185.02C267.686 184.667 267.589 184.237 267.589 183.73V180.52H268.489V183.61C268.489 184.15 268.626 184.567 268.899 184.86C269.172 185.147 269.546 185.29 270.019 185.29C270.506 185.29 270.889 185.14 271.169 184.84C271.449 184.54 271.589 184.103 271.589 183.53V180.52H272.499ZM276.706 180.42C277.372 180.42 277.912 180.623 278.326 181.03C278.739 181.43 278.946 182.01 278.946 182.77V186H278.046V182.9C278.046 182.353 277.909 181.937 277.636 181.65C277.362 181.357 276.989 181.21 276.516 181.21C276.036 181.21 275.652 181.36 275.366 181.66C275.086 181.96 274.946 182.397 274.946 182.97V186H274.036V180.52H274.946V181.3C275.126 181.02 275.369 180.803 275.676 180.65C275.989 180.497 276.332 180.42 276.706 180.42ZM265.28 194.03V199.18C265.28 199.753 265.103 200.213 264.75 200.56C264.397 200.9 263.93 201.07 263.35 201.07C262.763 201.07 262.293 200.897 261.94 200.55C261.587 200.197 261.41 199.717 261.41 199.11H262.32C262.327 199.45 262.413 199.727 262.58 199.94C262.753 200.153 263.01 200.26 263.35 200.26C263.69 200.26 263.943 200.16 264.11 199.96C264.277 199.753 264.36 199.493 264.36 199.18V194.03H265.28ZM271.933 195.52V201H271.023V200.19C270.849 200.47 270.606 200.69 270.293 200.85C269.986 201.003 269.646 201.08 269.273 201.08C268.846 201.08 268.463 200.993 268.123 200.82C267.783 200.64 267.513 200.373 267.313 200.02C267.119 199.667 267.023 199.237 267.023 198.73V195.52H267.923V198.61C267.923 199.15 268.059 199.567 268.333 199.86C268.606 200.147 268.979 200.29 269.453 200.29C269.939 200.29 270.323 200.14 270.603 199.84C270.883 199.54 271.023 199.103 271.023 198.53V195.52H271.933ZM276.139 195.42C276.806 195.42 277.346 195.623 277.759 196.03C278.173 196.43 278.379 197.01 278.379 197.77V201H277.479V197.9C277.479 197.353 277.343 196.937 277.069 196.65C276.796 196.357 276.423 196.21 275.949 196.21C275.469 196.21 275.086 196.36 274.799 196.66C274.519 196.96 274.379 197.397 274.379 197.97V201H273.469V195.52H274.379V196.3C274.559 196.02 274.803 195.803 275.109 195.65C275.423 195.497 275.766 195.42 276.139 195.42Z"
          fill="#C4C4C4"
        />
        <path
          d="M274 170L274 166"
          stroke="#585858"
          stroke-opacity="0.1"
          stroke-linecap="round"
        />
        <defs>
          <filter
            id="filter0_d_15960_152591"
            x="158.785"
            y="40.791"
            width="68.0586"
            height="68.0596"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="12.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_15960_152591"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_15960_152591"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_15960_152591"
            x1="157.5"
            y1="59.2041"
            x2="157.5"
            y2="157.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#B09FFF" stop-opacity="0.3" />
            <stop offset="1" stop-color="#8D79F6" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_15960_152591"
            x1="157.713"
            y1="59.2041"
            x2="157.713"
            y2="108.996"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6D3CD6" />
            <stop offset="1" stop-color="#75BBF8" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_15960_152591"
            x1="192.898"
            y1="49"
            x2="192.898"
            y2="158.079"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#B09FFF" stop-opacity="0.15" />
            <stop offset="1" stop-color="#8D79F6" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_15960_152591"
            x1="192.815"
            y1="60.791"
            x2="192.815"
            y2="78.8505"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6D3DD7" />
            <stop offset="1" stop-color="#75B9F8" />
          </linearGradient>
        </defs>
      </svg>
    );
  };
  const [expand, setExpand] = useState(false);
  const [open, setOpen] = useState(false);
  const [opendialog, setOpendialog] = useState(false);
  const [action, setAction] = useState('');

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    onDropdownChange(selectedValue);
    if (selectedValue === 10) {
      if (matches1250) {
        setOpenbuyermatch(true);
      } else {
        setAnchorEl(event.currentTarget);
      }
    } else {
      setOpenbuyermatch(false);
      setAnchorEl(null);
    }
  };

  return (
    <>
      {!openbuyermatch && (
        <div
          style={{
            alignItems: 'center',
            padding: matchessm ? '10px 10px' : popover && '20px',
          }}
        >
          <Grid container sx={{ width: matchessm ? '100%' : 'auto' }}>
            <Grid item sx={{ width: matchessm ? '100%' : 'auto' }}>
              <Stack
                sx={{ width: matchessm ? '93%' : '325px', height: '30px' }}
                style={{
                  justifyContent: 'flex-end',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  position: !ownercardpropaction && 'absolute',
                  top: 28,
                  backgroundColor: 'white',
                }}
              >
                <Grid onClick={onClose}>
                  <RightArrow />
                </Grid>
              </Stack>
            </Grid>
            <Grid
              item
              sx={{
                width: matchessm ? '100%' : 'auto',
              }}
            >
              <Grid
                container
                sx={{
                  marginTop: propertyOwner ? '-15px' : '22px',
                  width: matchessm ? '100%' : 'auto',
                }}
              >
                <Grid
                  item={expand ? 3 : 12}
                  sx={{
                    width: matchessm ? '100%' : 'auto',
                  }}
                >
                  <Stack
                    sx={{
                      width: matchessm ? '100%' : '325px',
                      height: '112px',
                    }}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      container
                      sx={{
                        paddingTop: '13px',
                        width: matchessm ? '100%' : 'auto',
                      }}
                    >
                      <Stack
                        sx={{
                          borderRadius: '10px',
                          background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                        }}
                        style={{
                          width: matchessm ? '100%' : '325px',
                          height: '67px',
                        }}
                        alignItems={'center'}
                        paddingTop={'21px'}
                      >
                        <Avatar
                          alt="Insightslogo"
                          src={Insightslogo}
                          style={{
                            width: '91px',
                            height: '91px',
                            alignItems: 'center',
                            position: 'relative',
                          }}
                        />
                      </Stack>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
              <Grid
                container
                paddingTop={'13px'}
                sx={{
                  width: matchessm ? '100%' : 'auto',
                }}
              >
                <Grid item>
                  <Stack
                    sx={{ width: '325px', height: '30px' }}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Grid item>
                      <Stack
                        sx={{ width: '102px', height: '30px' }}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography
                          sx={{ ...poppins600, fontSize: '20px' }}
                          style={{ color: '#000000' }}
                        >
                          Insights
                        </Typography>
                      </Stack>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
              {!propertyOwner ? (
                <Grid
                  container
                  sx={{
                    alignItems: 'center',
                    width: matchessm ? '100%' : 'auto',
                  }}
                >
                  <Stack
                    sx={{
                      alignItems: 'center',
                      border: '1px solid #E7E5E5',
                      borderRadius: '10px',
                      marginTop: '10px',
                      width: matchessm ? '100%' : '328px',
                      height: '283px',
                      justifyContent: 'center',
                    }}
                  >
                    <Stack
                      sx={{
                        width: '298px',
                        height: '38px',
                        background: '#F7F8F7',
                      }}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      <Typography
                        sx={{
                          textAlign: 'center',
                          ...poppins500,
                          ...fontsize14,
                          color: '#26344E',
                        }}
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        Property Onwership
                      </Typography>
                    </Stack>
                    <Box
                      sx={{
                        padding: '10px',
                        marginTop: '10px',
                        height: '205px',
                        width: '298px',
                        display: 'flex',
                        flexDirection: 'row',
                        background: '#FFFFFF',
                        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                        borderRadius: '6px',
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Stack spacing={2}>
                            <img
                              src={House}
                              alt="Five cats looking around a field."
                              height={'125px'}
                              width={'133px'}
                              style={{ borderRadius: '6px' }}
                            />
                            <Button
                              variant="outlined"
                              style={{
                                width: '130px',
                                height: '30px',
                                fontSize: '12px',
                                color: '#9A9A9F',
                                textTransform: 'none',
                                fontWeight: '400px',
                                fontFamily: 'Poppins',
                                borderColor: '#9A9A9F',
                                borderRadius: '6px',
                              }}
                            >
                              Appraisal
                            </Button>
                          </Stack>
                        </Grid>

                        <Grid item xs={6}>
                          <Stack direction={'column'} spacing={2}>
                            <Stack direction={'row'} spacing={2}>
                              <Stack
                                direction={'row'}
                                spacing={1}
                                alignItems={'center'}
                              >
                                <BedIcon />
                                <Typography
                                  sx={{
                                    fontWeight: '400px',
                                    fontSize: '12px',
                                    fontFamily: 'Poppins',
                                    color: '#000000',
                                  }}
                                >
                                  5
                                </Typography>
                              </Stack>
                              <Stack
                                direction={'row'}
                                spacing={1}
                                alignItems={'center'}
                              >
                                <ShowerIcon />
                                <Typography
                                  sx={{
                                    fontWeight: '400px',
                                    fontSize: '12px',
                                    fontFamily: 'Poppins',
                                    color: '#000000',
                                  }}
                                >
                                  2
                                </Typography>
                              </Stack>
                              <Stack
                                direction={'row'}
                                spacing={1}
                                alignItems={'center'}
                              >
                                <CarIcon />
                                <Typography
                                  sx={{
                                    fontWeight: '400px',
                                    fontSize: '12px',
                                    fontFamily: 'Poppins',
                                    color: '#000000',
                                  }}
                                >
                                  1
                                </Typography>
                              </Stack>
                            </Stack>
                            <Typography
                              sx={{
                                fontSize: '10px',
                                fontWeight: ' 400px',
                                fontFamily: 'Poppins',
                                color: '#666666',
                              }}
                            >
                              123 Fake Street North Bondi 2323
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '10px',
                                fontWeight: ' 400px',
                                fontFamily: 'Poppins',
                                color: '#666666',
                              }}
                            >
                              Last Sold :
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  fontFamily: 'Poppins',
                                  color: '#000000',
                                  fontWeight: 500,
                                }}
                              >
                                12/01/2001
                              </Typography>
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '10px',
                                fontWeight: ' 400px',
                                fontFamily: 'Poppins',
                                color: '#666666',
                              }}
                            >
                              Price :
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  fontFamily: 'Poppins',
                                  color: '#000000',
                                  fontWeight: 500,
                                }}
                              >
                                $1250,000
                              </Typography>
                            </Typography>

                            <Select
                              sx={{
                                ...poppins500,
                                fontSize: '12px',
                                color: '#112347',
                                border: '1px solid #6C2AD2',
                                width: '130px',
                                height: '30px',
                                borderRadius: '6px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                  border: 'none',
                                },
                              }}
                              label="Action"
                              value={dropdownValue}
                              onChange={handleDropdownChange}
                              displayEmpty
                              inputProps={{ 'aria-label': 'Without label' }}
                            >
                              <MenuItem value={''}>Action</MenuItem>
                              <MenuItem value={10}>Buyer Match</MenuItem>
                            </Select>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  </Stack>
                </Grid>
              ) : null}
              <Grid>
                <MarketMetricsGraphOne />
              </Grid>
              <Grid>
                <MarketMetricsGraphTwo />
              </Grid>
              <Grid>
                <MarketMetricsGraphThree />
              </Grid>
              <Grid>
                <MarketMetricsGraphFour />
              </Grid>
              <Grid>
                <Graph />
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}

      {openbuyermatch && (
        <>
          {matches1250 ? (
            <Popover
              open={openbuyermatch}
              anchorEl={anchorEl}
              onClose={handleClosebuyermatch}
              anchorReference="none"
              PaperProps={{
                style: {
                  position: 'absolute',
                  top: matchessm ? 0 : 125,
                  right: 0,
                  transform: 'translate(0, 0)',
                  width: matchessm ? '100vw' : 'auto',
                  maxWidth: matchessm ? '100%' : 'none',
                  minHeight: '100%',
                },
              }}
            >
              <BuyerCard2Buyermatch
                onClose={handleClosebuyermatch}
                buyerId={buyerId}
                selectedProperty={selectedProperty}
                popover={true}
              />
            </Popover>
          ) : (
            <Dialog
              PaperProps={{
                sx: {
                  position: 'relative',
                  right: matchessm ? 0 : -35,
                  top: matchessm ? 0 : 135,
                  minHeight: '100%',
                  width: expanded ? '80%' : '367px',
                  boxShadow: 'none',
                },
              }}
              hideBackdrop
              open={openbuyermatch}
              maxWidth={'lg'}
            >
              <DialogContent>
                <BuyerCard2Buyermatch onClose={handleClosebuyermatch} />
              </DialogContent>
            </Dialog>
          )}
        </>
      )}
    </>
  );
};
